import { connect } from "react-redux";
import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import Alert from "@/components/UI/Alert";
import { AriaRouterProvider } from "@/providers/AriaRouterProvider";
import ExceptionReport from "@/components/Common/ExceptionReport";
import { isConfigsLoaded } from "@/redux/reducers/configsReducer";
import { loadConfigs } from "@/redux/actions/configs";
import { loadFlags } from "@/redux/actions/featureFlag";
import { loadToken } from "@/redux/actions/auth";
import { privateFlagsLoaded, publicFlagsLoaded } from "@/redux/reducers/featureFlagReducer";
import { removeToast } from "@/redux/actions/toaster";
import Spinner from "@/components/UI/Spinner";
import { Toaster } from "@/component-library";
import { trackingRequests } from "@/api/(requests)/tracking";

import RouterFactory from "./RouterFactory/RouterFactory";

import "./App.scss";

class App extends Component {
  constructor(props) {
    super(props);
    if (!window.location.pathname.startsWith("/auth") && window.location.pathname !== "/") {
      window.localStorage.setItem(
        "redirectAfterAuth",
        window.location.pathname + window.location.search,
      );
    }
    this.state = {
      configsLoaded: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps !== this.props &&
      isConfigsLoaded(this.props.configs) &&
      publicFlagsLoaded(this.props.flags) &&
      (!this.props.auth.accessToken ||
        (this.props.auth.accessToken && privateFlagsLoaded(this.props.flags)))
    ) {
      this.setState({ configsLoaded: true });
    }
  }

  async componentDidMount() {
    this.props.loadToken();
    this.emailTracking();
    this.props.loadConfigs();
    this.props.loadFlags();
  }

  emailTracking() {
    const params = new URLSearchParams(window.location.search.substring(1));
    let campaignId = params.get("campaign_id");
    let entityId = params.get("entity_id");
    let cohort = params.get("cohort");

    if (campaignId != null && entityId != null && cohort != null) {
      let data = {
        action: "CLICKED",
        campaign_id: campaignId,
        cohort: cohort,
        entity_id: entityId,
      };

      // Fire-and-forget — tracking failures should never affect the user.
      trackingRequests.email({ data }).catch(console.log);
    }
  }

  render() {
    return (
      <Router>
        <AriaRouterProvider>
          <div className="container-fluid tw:relative tw:flex tw:min-h-screen tw:flex-col tw:justify-start tw:px-0!">
            {this.props.spinner.isLoading && <Spinner />}

            {this.props.alert && (
              <Alert
                buttonAction={this.props.alert.buttonAction}
                buttonText={this.props.alert.buttonText}
                customClass={this.props.alert?.customClass}
                customHTML={this.props.alert.customHTML}
                dismiss={this.props.alert.dismiss}
                message={this.props.alert.message}
                requestId={this.props.alert.requestId}
                show_exception_handling={this.props.alert.showExceptionReporting}
                type={this.props.alert.type}
              />
            )}

            {this.props.exceptionReport && (
              <ExceptionReport
                dismiss={this.props.exceptionReport.dismiss}
                requestId={this.props.exceptionReport.requestId}
              />
            )}

            <Toaster
              onDismissButtonClick={this.props.removeToast}
              toasts={this.props.toaster.toasts}
            >
              <></>
            </Toaster>

            {this.state.configsLoaded && <RouterFactory {...this.props} />}
          </div>
        </AriaRouterProvider>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    alert: state.alert.alertConf,
    auth: state.auth,
    configs: state.configs,
    exceptionReport: state.exceptionReport.exceptionReportConf,
    flags: state.flags,
    spinner: state.loader,
    toaster: state.toaster,
  };
};

export default connect(mapStateToProps, { loadConfigs, loadFlags, loadToken, removeToast })(App);
